import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguage } from './utils';

// Import translations
import translationEN from './locales/en.json';
import translationEs from './locales/es.json';

const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationEs
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    lng: getLanguage(),
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 